import React from 'react';
import { Icon } from 'leaflet';
import { Map, TileLayer, Marker, Popup } from 'react-leaflet';

export const daltonPosition = {
    lat: 54.1583,
    lng: -3.1789
};

const HouseMap = ({ data, onMarkerSelect, onMarkerDeselect, mapCenter=[daltonPosition.lat, daltonPosition.lng] }) => {
    const zoom = 14;
    const myIcon = new Icon({
        iconUrl: './poppy-marker.png',
        iconSize: [25, 41],
        iconAnchor: [12, 40],
        popupAnchor: [2, -32],
        shadowUrl: './poppy-marker-shadow.png',
        shadowSize: [30, 19],
        shadowAnchor: [0, 18]
    });

    return (
        <Map center={mapCenter} zoom={zoom}
             dragging={true}
             scrollWheelZoom={true}
             style={{ position:'absolute', top:0, left:0, right:0, bottom:0}}>
            <TileLayer
                attribution="&amp;copy <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            {data.map(soldier => {
                const { uid, lat, lng, firstname, middlenames, lastname, agedied, house, street, town } = soldier;

                // NO ADDRESS
                if (!house && !street && !town) {
                    return null;
                }

                if (lat && lng) {
                    return (
                        <Marker key={uid}
                                onPopupClose={() => onMarkerDeselect()}
                                position={{ lat, lng }}
                                icon={myIcon}
                                onClick={() => onMarkerSelect(uid)}>
                            <Popup>
                                {firstname} {middlenames} {lastname} <br/> Killed at {agedied}
                            </Popup>
                        </Marker>
                    )
                }
                return null;
            })
            }
        </Map>
    )
};

export default HouseMap;


// WEBPACK FOOTER //
// ./src/app/components/HouseMap.js